<template>
  <div class="sidebar-scroll">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="routesPath"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    ...mapState([ 'promission' ]),
    routes() {
      return this.promission.routes
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    routesPath() {
      return this.$route.meta.is_children ? this.$route.meta.children_path : this.$route.path
    }
  }
}
</script>
<style scoped>
.sidebar-scroll {
  height: 100vh!important; /* 或根据需要设置具体高度 */
  overflow-y: auto!important;
  -webkit-overflow-scrolling: touch!important; /* iOS 弹性滚动支持 */
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue